import { ColumnsType } from 'antd/es/table/interface';
import { TFunction } from 'i18next';
import { Link } from 'react-router-dom';

import {
	EyeOutlined,
	PlusOutlined,
	EditFilled,
	CheckCircleOutlined,
	CloseCircleOutlined,
	CaretUpOutlined,
	CaretDownOutlined,
} from '@ant-design/icons';

import { Tooltip } from 'antd';
import './countryAndPaymMethodColumn.scss';
import { handleSortClick } from './sorterColumn';
import { currency } from '../models/currency';
import { ColumnTitle } from '../components/ColumnTitle/ColumnTitle';

export const getCurrencyColumn = (
	t: TFunction<'translation', undefined, 'translation'>,
	sortBy: string,
	setSortBy: (sortValue: string) => void,
) => {
	const columns: ColumnsType<currency> = [
		{
			responsive: ['lg'],
			// TODO: will be added in the next sprint
			title: (
				<div>
					{/* <Link to={`/add-currency`} >
						<PlusOutlined className='p-3 flex items-center cursor-pointer  text-[20px] text-black font-bold' />
					</Link> */}
				</div>
			),
			dataIndex: 'add',
			key: 'add',
			width: 50,
			ellipsis: true,
			render: (value, record) => {
				return (
					<div>
						<Link to={`/add-currency?id=${record.id}`}>
							<EditFilled className='flex items-center cursor-pointer text-black font-bold' />
						</Link>
					</div>
				);
			},
		},
		{
			responsive: ['lg'],
			title: (
				<div className=' flex items-center cursor-pointer'>
					<ColumnTitle title={t<string>('currencyCode')} />
					<div className='flex flex-col mx-2 text-xs mt-1 '>
						<CaretUpOutlined
							onClick={() => setSortBy(handleSortClick(sortBy, 'currency-code-asc'))}
							style={{ color: sortBy === 'currency-code-asc' ? 'black' : 'gray' }}
						/>
						<CaretDownOutlined
							onClick={() => setSortBy(handleSortClick(sortBy, 'currency-code-desc'))}
							style={{ color: sortBy === 'currency-code-desc' ? 'black' : 'gray' }}
							className='-mt-[3px]'
						/>
					</div>
				</div>
			),
			dataIndex: 'currencyCode',
			key: 'currencyCode',
			ellipsis: true,
			render: (value, record) => {
				return <div className='text-[#00142A] flex items-centerfont-medium'>{record.currencyCode}</div>;
			},
		},
		{
			responsive: ['lg'],
			title: <ColumnTitle title={t<string>('buyMin')} />,
			dataIndex: 'country-code',
			key: 'country-code',
			render: (value, record) => {
				return (
					<div className=' text-[#626A74] flex items-center mb-1 font-medium'>{record.buyMin?.toLocaleString()}</div>
				);
			},
		},
		{
			responsive: ['lg'],
			title: <ColumnTitle title={t<string>('buyMax')} />,
			dataIndex: 'buyMax',
			key: 'buyMax',
			render: (value, record) => (
				<div className='text-[#626A74] flex items-center mb-1 font-medium'>{record.buyMax?.toLocaleString()}</div>
			),
		},
		{
			responsive: ['lg'],
			title: <ColumnTitle title={t<string>('sellMin')} />,
			dataIndex: 'sellMin',
			key: 'sellMin',
			render: (value, record) => {
				return (
					<div className=' font-medium text-[#000D1D99] flex items-center'>{record.sellMin?.toLocaleString()}</div>
				);
			},
		},
		{
			responsive: ['lg'],
			title: <ColumnTitle title={t<string>('sellMax')} />,
			dataIndex: 'sellMax',
			key: 'sellMax',
			render: (value, record) => (
				<div className=' font-medium text-[#000D1D99] flex items-center'>{record.sellMax?.toLocaleString()}</div>
			),
			ellipsis: true,
		},
		{
			responsive: ['lg'],
			title: (
				<div className=' text-[#000D1D99] text-sm flex items-center cursor-pointer'>
					<ColumnTitle title={t<string>('public')} />
					<div className='flex flex-col mx-2 text-xs mt-1'>
						<CaretUpOutlined
							onClick={() => setSortBy(handleSortClick(sortBy, 'is-public-asc'))}
							style={{ color: sortBy === 'is-public-asc' ? 'black' : 'gray' }}
						/>
						<CaretDownOutlined
							onClick={() => setSortBy(handleSortClick(sortBy, 'is-public-desc'))}
							style={{ color: sortBy === 'is-public-desc' ? 'black' : 'gray' }}
							className='-mt-[3px]'
						/>
					</div>
				</div>
			),
			dataIndex: 'isPublic',
			key: 'isPublic',
			render: (value, record) => {
				return (
					<div
						className='flex items-center  font-medium text-[#000]'
						style={{ color: record.isPublic ? 'green' : 'red' }}
					>
						{record.isPublic ? t<string>('yes') : t<string>('no')}
					</div>
				);
			},
		},
		{
			dataIndex: 'record',
			title: <div></div>,
			className: 'small-screen-row',
			render: (value, row) => {
				return (
					<div className='flex py-2 pb-0 justify-between'>
						<div className='flex-col w-full'>
							<div className='flex flex-row justify-between'>
								<div className='text-[#00142A66] '>{t<string>('currencyCode')}</div>
								<div className='flex'>
									<Link to={`/add-currency?id=${row.id}`}>
										<EditFilled className='px-2 flex items-center cursor-pointer  text-[20px] text-black font-bold' />
									</Link>
									<div className='text-[14px] text-[#00142A] flex items-center mb-1 font-medium'>
										{row.currencyCode}
									</div>
								</div>
							</div>
							<div className=' text-[#00142A66] flex justify-between m-0  p-0'>
								<div>{t<string>('buyMin')}</div>
								<div className='inline-block mx-1 text-lightBlue text-[13px]'>{row.buyMin?.toLocaleString()}</div>
							</div>
							<div className='flex justify-between  items-center h-6'>
								<span className=' text-[#00142A66] '>{t<string>('buyMax')}</span>
								<span className='text-xs text-lightBlue mx-2'>{row.buyMax?.toLocaleString()}</span>
							</div>
							<div className='flex justify-between items-center h-6'>
								<span className=' text-[#00142A66] '>{t<string>('sellMin')}</span>
								<span className='inline-block mx-1 text-[#000] text-[13px]'>{row.sellMin?.toLocaleString()}</span>
							</div>
							<div className='flex justify-between items-center h-6'>
								<span className='  text-[#00142A66] '>{t<string>('sellMax')}</span>
								<span className='inline-block mx-1 text-[#000] text-[13px]'>{row.sellMax?.toLocaleString()}</span>
							</div>
							<div className='flex justify-between items-center h-6'>
								<span className=' text-[#00142A66] '>{t<string>('public')}</span>
								<div
									className='flex items-center  font-medium text-[#000]'
									style={{ color: row.isPublic ? 'green' : 'red' }}
								>
									{row.isPublic ? t<string>('yes') : t<string>('no')}
								</div>
							</div>
						</div>
					</div>
				);
			},
		},
	];

	return columns;
};
